var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"objects-table"},[_c('e-table-inner',{attrs:{"visibleColumns":_vm.visibleColumns,"itemsEndpoint":_vm.getObjectsEndpoint,"showDeleteButton":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }